import React, { useState } from 'react'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import CopyIcon from '@assets/images/icon/copy.svg'
import FaqBanner from '@assets/images/icon/faq-question-banner.svg'
import { Accordion, AccordionButton } from 'react-bootstrap'
import { TOAST_TYPE } from '@shared/constants'
import { fireToast } from '@shared/components/toastr/toastr.helper'

function FaqAdvertise() {
  const [activeIndex, setActiveIndex] = useState(0)
  const faq = [
    {
      title: 'Process and Collaboration',
      questions: [
        {
          id: '01',
          q: 'Can you work with businesses in any industry?',
          a: 'Yes, we cater to a variety of industries, including e-commerce, real estate, healthcare, technology, sports, and more.'
        },
        {
          id: '02',
          q: 'How do we get started?',
          a: 'Schedule a consultation with us, and we’ll assess your needs to create a custom strategy for your brand.'
        },
        {
          id: '03',
          q: 'Do I need to provide content, or will you create it?',
          a: 'We can handle everything, including content creation, or collaborate with you if you prefer to provide materials.'
        },
        {
          id: '04',
          q: 'Can you run paid advertising campaigns?',
          a: 'Yes, we specialize in creating and managing paid ad campaigns on platforms like Facebook, Instagram, Google, and LinkedIn.'
        }
      ]
    },
    {
      title: 'Pricing and Packages',
      questions: [
        {
          id: '11',
          q: 'Do you offer customized packages?',
          a: 'Yes, we create tailored packages based on your business needs and goals.'
        },
        {
          id: '12',
          q: 'Do you offer discounts for long-term contracts?',
          a: 'Yes, we provide special pricing for long-term collaborations.'
        }
      ]
    },
    {
      title: 'Results and Performance',
      questions: [
        {
          id: '21',
          q: 'How long will it take to see results?',
          a: 'Social media growth takes time, but you may start seeing engagement improvements within 1-2 months. Significant results often take 3-6 months.'
        },
        {
          id: '22',
          q: 'What metrics do you track to measure success?',
          a: 'We track metrics like reach, engagement, impressions, website traffic, lead generation, and conversions, depending on your goals.'
        }
      ]
    },
    {
      title: 'Other Questions',
      questions: [
        {
          id: '31',
          q: 'What if I have a problem or concern?',
          a: 'You can contact your account manager or our support team at any time. We aim to resolve concerns promptly.'
        },
        {
          id: '32',
          q: 'Do you offer influencer marketing services?',
          a: 'Yes, we collaborate with influencers to create impactful campaigns that resonate with your target audience.'
        },
        {
          id: '33',
          q: 'Do you create websites or offer SEO services?',
          a: 'Yes, we have an in-house team for web development and SEO services.'
        },
        {
          id: '34',
          q: 'Can you handle crisis management on social media?',
          a: 'Yes, we have experience managing social media crises and can help protect your brand reputation.'
        },
        {
          id: '35',
          q: 'How can I contact your team?',
          a: 'You can reach us via email, phone, or our website’s contact form. Our support team is available during business hours.'
        }
      ]
    }
  ]

  const handleCopy = (e) => {
    navigator.clipboard.writeText('crictracker@gmail.com')
    fireToast({ message: 'Copied!', type: TOAST_TYPE.Success })
  }

  return (
    <div className={`${styles.faqWrapper}`}>
      <div className={`${styles.faqGroup} mb-md-4 mb-3`}>
        {faq.map((q, i) => (
          <button
            key={`b-${i}`}
            className={`${styles.faqTab} ${activeIndex === i ? styles.Tabactive : ''}`}
            onClick={() => setActiveIndex(i)}
          >
            {q.title}
          </button>
        ))}
      </div>
      <div className={`${styles.accordionMain}`}>
        <Accordion className={`${styles.accordionMain} overflow-hidden`} defaultActiveKey={faq[activeIndex].questions[0].id}>
          {faq[activeIndex].questions.map((q, index) => (
            <Accordion.Item eventKey={q.id} key={index} className={`${styles.accordionItem}`}>
              <AccordionButton className={`${styles.accordionButton} position-relative fw-bold rounded-0`}>{q.q}</AccordionButton>
              <Accordion.Body className={`${styles.accordionBody} mt-0 d-block pb-3 pt-0 px-3`}>{q.a}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
      <div className={`${styles.faqQuestion} position-relative mt-4`}>
        <MyImage className={`${styles.faqbanner}`} src={FaqBanner} alt="FaqBanner" />
        <h3 className="mb-lg-3 mb-2">Have any other Question?</h3>
        <p className="mb-3">Don’t hesitate to send us an email with your enquiry or statement at:</p>
        <div className={`${styles.faqCopy} d-flex align-items-center`}>
          crictracker@gmail.com
          <button onClick={handleCopy}>
            <MyImage src={CopyIcon} alt="copyicon" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default FaqAdvertise
